import React, { Component } from "reactn";
import { Icon } from "@material-ui/core";
import classNames from "classnames";
import styled from "styled-components";
import { themeColors } from "js/react/sharedStyles";

const NavContainer = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
`;
const NavContent = styled.div`
    padding-top: 30px;
    width: 400px;
    overflow-y: auto;
    overflow-x: hidden;

    &.navHidden {
        width: 520px;
    }

    & h4 {
        color: #333;
        margin-bottom: 12px;
    }
`;
const NavOptions = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #333;
`;
const NavBar = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 120px;
    position: relative;
    margin-top: 0;
`;
const NavItem = styled.div`
    color: #fff;
    padding: 20px 8px;
    text-align: center;
    transition: all 400ms ease-in;
    cursor: pointer;

    .material-icons {
        display: block;
        margin-bottom: 4px;
        font-size: 24px;
        width: auto;
    }
    label {
        text-transform: uppercase;
        font-size: 12px;
        cursor: inherit;
    }
    &:first-child {
        padding-top: 24px;
    }
    &:last-child {
        padding-bottom: 28px;
        margin-bottom: 0;
    }
    &:hover {
        & .material-icons {
            color: ${themeColors.ui_blue}
        };
        & label {
            color: ${themeColors.ui_blue}
        }
    }

    &.selected {
        font-weight: bold;
        color: ${themeColors.ui_blue};
        cursor: default;

        & .material-icons {
            color: ${themeColors.ui_blue};
        }
        & label {
            color: ${themeColors.ui_blue};
        }
    }
`;

export default class ThemeNav extends Component {
    constructor(props) {
        super(props);
    }

    render = () => {
        let {
            hideOptionsWhenSelected = [],
            selected,
            changeNavSelection,
        } = this.props;

        let children = React.Children.toArray(this.props.children);

        let hideNav = hideOptionsWhenSelected.includes(selected);

        let navItems = children.map(child => {
            let {
                navLabel,
                navIcon,
                navId,
                navAlign = "top",
            } = child.props;

            return {
                label: navLabel,
                icon: navIcon,
                id: navId,
                align: navAlign,
            };
        });

        let topNavItems = navItems.filter(x => x.align === "top");
        let bottomNavItems = navItems.filter(x => x.align === "bottom");

        let selectedChild = children.find(x => x.props.navId === selected);
        selectedChild = React.cloneElement(selectedChild, {
            changeNavSelection,
        });

        const renderNavItem = item => (
            <NavItem
                key={item.id}
                id={`theme-nav-${item.id}`}
                className={classNames({
                    selected: selected === item.id
                })}
                onClick={() => changeNavSelection(item.id)}
            >
                {item.icon && <Icon>{item.icon}</Icon>}
                <label>{item.label}</label>
            </NavItem>
        );

        return (
            <NavContainer>
                {
                    !hideNav &&
                    <NavOptions>
                        <NavBar>
                            <div>
                                {topNavItems.map(item => renderNavItem(item))}
                            </div>
                            {
                                bottomNavItems &&
                                <div>
                                    {bottomNavItems.map(item => renderNavItem(item))}
                                </div>
                            }
                        </NavBar>
                    </NavOptions>
                }
                <NavContent
                    className={classNames({
                        navHidden: hideNav,
                    })}
                >
                    {selectedChild}
                </NavContent>
            </NavContainer>
        );
    }
}
